import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import HelpTooltip from "../../../components/help-tooltip/help-tooltip.component";
import { CMArtistMomentum, CMArtistStageChart } from "./graph-momentum.styles";
import { useEffect, useState } from 'react';
import { ARTIST_CAREER, CAREER, NETWORK_STRENGTH, SOCIAL_ENGAGMENT } from "../../../Services/fake/artist";

const GraphMomentum = ({ auction, selectedTrack }) => {
    const [stageData, setStageData] = useState([]);
    const [growthData, setGrowthData] = useState([]);
    const [networkStrengthData, setNetworkStrengthData] = useState([]);
    const [socialEngagmentData, setocialEngagmentData] = useState([]);
    const [messageFail, setMessageFail] = useState("This song has no Artist Momentum");
    let tracks = auction.tracks;
    const [momentum, setMomentum] = useState(tracks[selectedTrack]?.artist_momentum)
    const parseJSON = () => {
        try {
            return momentum ? JSON.parse(momentum) : null;
        } catch (error) {
            console.error("Error parsing 'momentum' data:", error);
            setMessageFail("Artist Momentum information is incorrect, please verify your information");
            return null;
        }
    }
    const [momentumJson, setMomentumJson] = useState(() => parseJSON());
    const [Career, setCareer] = useState(momentumJson?.careerStage);
    const [Network, setNetwork] = useState(momentumJson?.networkStrength);
    const [Social, setSocial] = useState(momentumJson?.socialEngagement);


    const capitalizeFirstLetter = (string) => {
        if(string){
           return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase(); 
        }
    };

    useEffect(() => {
        if (!auction || !Career || !Network || !Social) {
            return;
        }
        const career = Career
        const network = Network
        const social = Social
        var stageData = [];
        var stageReverse = stageOptions.slice().reverse();
        for (var i = 0; i < stageReverse.length; i++) {
            stageData.push({ name: stageReverse[i], value: 3, color: COLORS[i]})
            if(stageReverse[i] === capitalizeFirstLetter(career.career_stage)) break;
        }
        for (var i = stageData.length; i < stageReverse.length; i++) {
            stageData.push({ name: stageReverse[i], value: 3, color: "#d0d0d0"})
        }
        setStageData(stageData);
        var growthData = [];
        var growthReverse = growthOptions.slice().reverse();
        for (var i = 0; i < growthReverse.length; i++) {
            growthData.push({ name: growthReverse[i], value: 3, color: COLORS[i]})
            if(growthReverse[i] === capitalizeFirstLetter(career.recent_momentum)) break;
        }
        for (var i = growthData.length; i < growthReverse.length; i++) {
            growthData.push({ name: growthReverse[i], value: 3, color: "#d0d0d0"})
        }
        setGrowthData(growthData);
        var networkStrengthData = [];
        var networkStrengthReverse = networkStrengthOptions.slice().reverse();
        for (var i = 0; i < networkStrengthReverse.length; i++) {
            networkStrengthData.push({ name: networkStrengthReverse[i], value: 3, color: COLORS[i] })
            if(networkStrengthReverse[i] === capitalizeFirstLetter(network.label)) break;
        }
        for (var i = networkStrengthData.length; i < networkStrengthReverse.length; i++) {
            networkStrengthData.push({ name: networkStrengthReverse[i], value: 3, color: "#d0d0d0"})
        }
        setNetworkStrengthData(networkStrengthData);

        var socialEngagmentData = [];
        var socialEngagmentReverse = socialEngagmentOptions.slice().reverse();
        for (var i = 0; i < socialEngagmentReverse.length; i++) {
            socialEngagmentData.push({ name: socialEngagmentReverse[i], value: 3, color: COLORS[i] })
            if(socialEngagmentReverse[i] === capitalizeFirstLetter(social.label)) break;
        }
        for (var i = socialEngagmentData.length; i < socialEngagmentReverse.length; i++) {
            socialEngagmentData.push({ name: socialEngagmentReverse[i], value: 3, color: "#d0d0d0"})
        }
        setocialEngagmentData(socialEngagmentData);
        
    }, [Career, Network, Social])

    useEffect(()=>{
        setMomentum(tracks[selectedTrack]?.artist_momentum)
    },[selectedTrack])

    useEffect(()=>{
        setMomentumJson(parseJSON())
    },[momentum])
        
    useEffect(()=>{
        const career = momentumJson?.careerStage
        const network = momentumJson?.networkStrength
        const social = momentumJson?.socialEngagement
        if(career) {
            setCareer({stage: career.career_stage ?? null, growth: career.recent_momentum ?? null, network_strength: network.label ?? null, social: social.label ?? null});
        }
        if(network) {
            setNetwork(momentumJson?.networkStrength)
        }
        if(social) {
            setSocial(momentumJson?.socialEngagement)
        }
    },[momentumJson])
  
    return (
        (momentumJson && Career && Network && Social)
        ?
        <CMArtistMomentum>
            <div className="artist-stage">
                <ArtistStageChart  key={'Career Stage'} title={'Career Stage'} tooltip={'Career Stage'} data={stageData} options={stageOptions} active={capitalizeFirstLetter(Career.stage)} auction={auction}/>
                <ArtistStageChart  key={'Career2 Stage'} title={'Recent Momentum'} tooltip={'Career Stage'} data={growthData} options={growthOptions} active={capitalizeFirstLetter(Career.growth)} auction={auction}/>
                <ArtistStageChart  key={'Career3 Stage'} title={'Network Strength'} tooltip={'Career Stage'} data={networkStrengthData} options={networkStrengthOptions} active={capitalizeFirstLetter(Career.network_strength)} auction={auction}/>
                <ArtistStageChart  key={'Career4 Stage'} title={'Social Engagment'} tooltip={'Career Stage'} data={socialEngagmentData} options={socialEngagmentOptions} active={capitalizeFirstLetter(Career.social)} auction={auction}/>
            </div>
        </CMArtistMomentum>
        :
        <>
            <h5>This song has no Artist Momentum</h5>
        </>
    ); 
    
}

const stageOptions = ['Legendary', 'Superstar', 'Mainstream', 'Mid-Level', 'Developing'];

const growthOptions = ['Explosive Growth', 'Growth', 'Steady', 'Gradual Decline', 'Decline'];

const networkStrengthOptions = ['Influential', 'Prominent', 'Established', 'Emerging', 'Active'];

const socialEngagmentOptions = ['Influential', 'Prominent', 'Established', 'Emerging', 'Active'];

const COLORS = ['#3b6ba9', '#62a3d1', '#ade0e5', '#72d9af', '#0da17c'];

const ArtistStageChart = ({ title, tooltip, options, data = [], active, ...props }) => (
    <CMArtistStageChart {...props}>
        <div className="chart-content">
            <div className="chart-inner">
                <div className="chart-size">
                    <div className="chart-title">
                        <h6>
                            {title}
                            <HelpTooltip title={tooltip} />
                        </h6>
                    </div>
                    <ResponsiveContainer>
                        <PieChart>
                        <Pie
                                 dataKey="value"
                                 data={data}
                                 startAngle={180}
                                 endAngle={0}
                                 innerRadius="90%"
                                 outerRadius="100%"
                                 paddingAngle={1}
                                 cornerRadius={2}
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                            <foreignObject x="0" y="0" width="100%" height="100%">
                                <div className="chart-label">
                                    <span>{active}</span>
                                </div>
                            </foreignObject>
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                <div className="chart-options">
                    {options.map((option, index) => (
                        <div key={`option-${index}`} className={option === active ? 'active' : ''}>
                            {option === active && (
                                <img src="https://storage.googleapis.com/cm-app-assets/icons/arrow-right.svg" alt="active arrow" />
                            )}
                            {option}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </CMArtistStageChart>
);

export default GraphMomentum;